import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "p-4 mx-auto max-w-2xl bg-gray-50 rounded-md"
};
const _hoisted_2 = {
  class: "flex items-center"
};
const _hoisted_3 = {
  class: "flex-1 ml-3 md:flex md:justify-between"
};
const _hoisted_4 = {
  class: "text-base font-medium tracking-wide text-gray-800"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "flex-shrink-0"
  }, [_createElementVNode("span", {
    class: "flex relative w-3 h-3"
  }, [_createElementVNode("span", {
    class: "inline-flex absolute w-full h-full bg-gray-400 rounded-full opacity-75 animate-ping"
  }), _createElementVNode("span", {
    class: "inline-flex relative w-3 h-3 bg-gray-500 rounded-full"
  })])], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, " Loading " + _toDisplayString($props.what) + "... ", 1)])])]);
}